export default "__VITE_ASSET__CVCyxDGR__"